import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Pickup',
        [ORDER_METHODS.DELIVERY]: 'Delivery',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Room service',
          [RoomServiceLocationType.TableService]: 'Table service',
        },
      },
    },
    delivery_info: {
      title: 'Delivery details',
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Payment',
    },
    request_invoice: {
      title: 'Request invoice',
      form: {
        is_receipt_required: {
          label: 'Request invoice via email',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Ring door bell',
        [DropoffAction.Sms]: 'Contact me via SMS upon arrival',
      },
    },
  },
  buttons: {
    change: 'Change',
    add_delivery_note: 'Add delivery instruction',
  },
};
